// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"404":"06572bd1","686":"06572bd1"}[chunkId] + ".chunk.css";
};